import { render, staticRenderFns } from "./consentManagement.vue?vue&type=template&id=f7fbd1ea&"
import script from "./consentManagement.vue?vue&type=script&lang=js&"
export * from "./consentManagement.vue?vue&type=script&lang=js&"
import style0 from "./consentManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7fbd1ea')) {
      api.createRecord('f7fbd1ea', component.options)
    } else {
      api.reload('f7fbd1ea', component.options)
    }
    module.hot.accept("./consentManagement.vue?vue&type=template&id=f7fbd1ea&", function () {
      api.rerender('f7fbd1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consentManagement/consentManagement.vue"
export default component.exports